import styled from 'styled-components';

export const Label = styled.p`
  text-align: left;
  margin: 0px;
`;

export const InputContain = styled.section`
  position: relative;
  margin-bottom: 12px;
  p {
    margin: 0 0 0.7rem;
    color: var(--texto-color);
    letter-spacing: 0.1rem;
    font-size: var(--font-tamanho);
  }
  input {
    width: 100%;
    margin-bottom: 1rem;
    height: 50px;
    padding: 10px 12px;
    /* border-radius: 0.5rem; */
    &::placeholder {
      color: var(--grey-color-sefaz);
    }
  }
  span {
    top: 10px;
    position: absolute;
    right: 15px;
    font-size: 3rem;
    color: var(--primary-color-sefaz);
  }
  .ant-input {
    border-radius: 6px;
  }
`;
